import { Box, FormHelperText } from "@mui/material";
import { StyledInputGrid } from "customStyled";
import FormLabel from "./FormLabel";
import { FieldErrorContext } from "./FieldErrorIcon";
import { fieldErrorMessages } from "./fieldErrorMessages";

// Kept for screen readers (the input's aria-describedby), not shown
const visuallyHidden = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px",
};

const FormControlUI = ({
  id,
  isError = false,
  required = false,
  // not used any more: every field shows its error on the icon
  showHoverError = false,
  disabled = false,
  showHelperWithError = true,
  errorMsg = [],
  helperText,
  sx = {},
  children,
  label = null,
  hasError = () => false,
  // the field's failing rules: rules without a message in errorMsg get a
  // default one ("City is required")
  errors = null,
}) => {
  let errorText = null;
  if (isError && errorMsg.length) {
    errorText = errorMsg.filter((el, index) => hasError(el.validation));
  }

  const messages = errors
    ? isError
      ? fieldErrorMessages({ errors, errorMsg, label })
      : []
    : errorText?.length
      ? errorText.map((el) => el.errorMsg)
      : [];

  return (
    <StyledInputGrid sx={{ ...sx }} disabled={disabled} error={isError}>
      <FormLabel label={label} required={required} id={id} />
      {/* the message shows when hovering the field's error icon (FieldErrorIcon) */}
      <FieldErrorContext.Provider value={messages}>{children}</FieldErrorContext.Provider>
      {messages.length ? (
        <Box id={`${id}-error-text`} sx={visuallyHidden}>
          {messages.map((msg, index) => (
            <span key={index}>*{msg}</span>
          ))}
        </Box>
      ) : null}

      {(showHelperWithError ? true : !isError) && helperText ? (
        <FormHelperText id={`${id}-helper-text`}>{helperText}</FormHelperText>
      ) : null}
    </StyledInputGrid>
  );
};

export default FormControlUI;
